<template>
  <div class="project_list">
    <!--  <div class="project_list_header">
      <el-row>
        <el-col :span="4">
          <div class="grid-content bg-purple">
            年度预算: {{ curYear[1] ? num(curYear[1].value) : "" }}
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple">
            完成建设: {{ curYear[2] ? num(curYear[2].value) : "" }}
          </div>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="4">
          <div class="grid-content bg-purple">
            拟建项目: {{ curYear[0] ? curYear[0].value : "" }}个
          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">
            完成建设: {{ curYear[3] ? curYear[3].value : "" }}个
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <span>建设中的项目: {{ curYear[4] ? curYear[4].value : "" }}个</span>
            <span v-show="curYear[5] ? (curYear[5].value > 0 ? true : false) : false"
              >,{{ curYear[5] ? curYear[5].value : "" }}个项目延迟超过30天！</span
            >
          </div>
        </el-col>
      </el-row>
    </div> -->
    <Row
      :gutter="8"
      style="margin: 0px 0 0 0; width: 100%"
      v-if="menus && menus.length > 0"
    >
      <Menu
        mode="horizontal"
        :active-name="menu_name"
        @on-select="selectMenu"
        style="width: 100%"
      >
        <div v-for="(v, k) in menus" style="display: inline-block" :key="k">
          <MenuItem :name="v.name" v-auth="v.auth" @click="v.onClick">
            <Badge
              :overflow-count="10000000"
              v-if="v.badge && v.badge.count"
              :offset="[18, -3]"
            >
              {{ v.label }}
            </Badge>
            <span v-if="!(v.badge && v.badge.count)">
              {{ v.label }}
            </span>
          </MenuItem>
        </div>
      </Menu>
    </Row>
    <div class="project_list_action">
      <el-button type="primary" plain size="medium" icon="el-icon-plus" @click="toAdd"
        >新建项目</el-button
      >
      <el-button
        type="primary"
        plain
        size="medium"
        icon="el-icon-download"
        @click="getexport"
        >导出预算表</el-button
      >
      <!-- <el-button type="primary" plain size="medium" @click="load2(2)">完成建设</el-button> -->
      <el-input
        style="margin-left: 10px"
        placeholder="请输入项目名称"
        v-model="content"
        size="medium"
      ></el-input>
      <el-button
        style="margin-left: 10px"
        plain
        size="small"
        icon="el-icon-search"
        type="primary"
        @click="toSearch(content)"
        >搜索</el-button
      >
      <el-button size="small" icon="el-icon-circle-close" @click="load()">重置</el-button>
    </div>
    <div class="project_list_table">
      <el-table
        :data="tableData"
        style="width: 100%; margin-bottom: 20px"
        row-key="id"
        height="650"
        border
        :indent="10"
        :tree-props="{
          children: 'sysProjectManagementResponses',
          hasChildren: 'hasChildren',
        }"
      >
        <el-table-column label="序号" align="center" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.indexId }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="projectType" label="项目类型" min-width="220">
        </el-table-column>
        <el-table-column label="项目" min-width="300">
          <template slot-scope="scope">
            <div class="name">
              <p
                style="color: #2d41ef; cursor: pointer; margin-right: 3px"
                @click="toInfo(scope.row.id)"
              >
                {{ scope.row.name }}
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="stateName" label="进度节点" align="center" width="80">
        </el-table-column>
        <el-table-column
          prop="projectLeaderName"
          label="负责人"
          align="center"
          width="70"
        >
        </el-table-column>
        <el-table-column prop="totalTask" label="任务" align="center" width="50">
        </el-table-column>
        <el-table-column label="预算(元)" align="center" width="140">
          <template slot-scope="scope">
            <p>
              {{ num(scope.row.budget) }}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="合同金额(元)" align="center" width="140">
          <template slot-scope="scope">
            <p>
              {{ num(scope.row.contractMoney) }}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="耗时/预时(天)" width="90" align="center">
          <template slot-scope="scope">
            <p>
              {{ scope.row.useTime > 0 ? scope.row.useTime : 0 }}/{{ scope.row.moveTime }}
            </p>
          </template>
        </el-table-column>

        <el-table-column label="操作" fixed="right" align="center" width="120">
          <template v-slot="scope">
            <el-button type="text" @click="edit(scope.row.id)">编辑</el-button>
            <el-button type="text" @click="del(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import config from "../../../config";
import baseList from "@/views/components/base/baseList.vue";
let customerId = window.localStorage.getItem("customerId");
export default {
  extends: baseList,

  data() {
    return {
      tableData: [],
      page: 1,
      total: "",
      pageSize: 20,
      curYear: [],
      content: "",
      percentage: 0,
      urldata: "",
      menus: [
        {
          label: "全部项目",
          name: "project_list",
          auth: "",
        },
        {
          label:Number(customerId) == 0 ? '跟进中' : '建设中',
          name: "project_list1",
          auth: "",
        },
        {
          label:Number(customerId) == 0 ? '已成交' : '已完成',
          name: "project_list2",
          auth: "",
        },
        {
          label: "已归档",
          name: "project_list3",
          auth: "",
        },
      ],
    };
  },
  created() {
    this.load();
    //this.getcurYearData();
  },
  methods: {
    num(num) {
      return (num = new Intl.NumberFormat("zh-CN", {
        style: "currency",
        currency: "CNY",
      }).format(num));
    },
    async toSearch(val) {
      let q = {
        pageSize: this.pageSize,
        page: this.page,
        name: val,
        status: 1,
      };
      let res = await $utils.api.load("/admin/system/management/list", q, "get");
      if (res.code == 200) {
        this.total = res.total;
        let list = res.rows;
        list.forEach((item, index) => {
          item.indexId = index + 1;
          if (item.sysProjectManagementResponses) {
            item.sysProjectManagementResponses.forEach((items, indexs) => {
              items.indexId = item.indexId + "." + (indexs + 1);
            });
          }
        });
        this.tableData = list;
      }
    },
    toAdd() {
      $utils.url.push({
        name: "add_project",
      });
    },
    async del(val) {
      let q = {};
      let res = await $utils.api.load(`/admin/system/management/${val}`, q, "DELETE");
      if (res.code == 200) {
        this.$Modal.remove();
        $utils.toast.success("删除成功");
        this.load();
      }
    },
    edit(val) {
      $utils.url.push({
        name: "add_project",
        query: { action: "edit", id: val },
      });
    },
    toInfo(row) {
      window.localStorage.setItem("projectId", row);
      $utils.url.push({
        name: "panorama",
      });
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.page = 1;
      this.load();
    },
    handleCurrentChange(currentSize) {
      this.page = currentSize;
      this.load();
    },
    async load() {
      this.content = "";
      let q = {
        pageSize: this.pageSize,
        page: this.page,
        status: 1,
      };
      let res = await $utils.api.load("/admin/system/management/list", q, "get");
      if (res.code == 200) {
        this.total = res.total;
        let list = res.rows;
        list.forEach((item, index) => {
          item.indexId = index + 1;
          if (item.sysProjectManagementResponses) {
            item.sysProjectManagementResponses.forEach((items, indexs) => {
              items.indexId = item.indexId + "." + (indexs + 1);
            });
          }
        });
        this.tableData = list;
      }
    },
    async getcurYearData() {
      let res = await $utils.api.load("/admin/system/management/curYearData", {}, "get");
      if (res.code == 200) {
        this.curYear = res.data;
      }
    },
    async getexport() {
      let q = {};
      this.$Message.info("数据正在导出，请稍后");
      $utils.api
        .load(`/admin/system/management/export`, q, "GET")
        .then((res) => {
          if (res.code == 200) {
            this.urldata = res.msg;
            window.location.href =
              config.API_HOST + `/admin/common/download?fileName=${this.urldata}`;
          }
        })
        .catch((err) => {
          $utils.loading.hide();
        });
    },
  },
};
</script>
<style lang="less" scoped>
.project_list_action {
  display: flex;
  margin: 10px 0;
}

/deep/.el-pagination {
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/deep/.active {
  background-color: rgb(255, 255, 255) !important;
}

.name {
  display: flex;
  .green {
    background-color: #e4f3e5;
    color: #4baf50;
    border-radius: 5px;
    padding: 0 5px;
  }
  .red {
    background-color: #fcd9dd;
    color: #ec0019;
    border-radius: 5px;
    padding: 0 5px;
  }
  .yellow {
    background-color: #fafcd9;
    color: #bdc824;
    border-radius: 5px;
    padding: 0 5px;
  }
}
</style>
